import { FC } from "react"
import { CONFIG_ADMIN_INPUT_FULL_CLASS } from "../../../config-admin-form-primitives"
import BBSwitch from "../../../../form/Switch"

interface TermLoanRowProps {
  loanKey: string
  defaultLabel: string
  labelValue: string
  enabled: boolean
  onLabelChange: (v: string) => void
  onEnabledChange: (v: boolean) => void
}

const TermLoanRow: FC<TermLoanRowProps> = ({
  loanKey,
  defaultLabel,
  labelValue,
  enabled,
  onLabelChange,
  onEnabledChange
}) => (
  <div className="px-4 py-3">
    <div className="flex items-center gap-4">
      <div className="min-w-0 flex-1">
        <input
          id={`rate-card-term-${loanKey}`}
          type="text"
          value={labelValue}
          onChange={e => onLabelChange(e.target.value)}
          disabled={!enabled}
          placeholder={defaultLabel}
          className={CONFIG_ADMIN_INPUT_FULL_CLASS}
          aria-label={defaultLabel}
        />
      </div>
      <div className="shrink-0 self-center">
        <BBSwitch enabled={enabled} setEnabled={onEnabledChange} />
      </div>
    </div>
    <p className="mt-1 font-mono text-xs text-gray-400">{loanKey}</p>
  </div>
)

export default TermLoanRow
